import type { SettingsTemplateModel } from '@/shared/generated'

import { useDraggable } from '@dnd-kit/core'
import { GripVerticalIcon } from 'lucide-react'

import { linkButtonVariants } from '@/shared/components/ui/link-button'
import { useModals } from '@/shared/lib/modal-manager'
import { cn } from '@/shared/lib/utils'

type BuilderBlockElementProps = {
	block: SettingsTemplateModel
}

export default function BuilderBlockElement({
	block,
}: BuilderBlockElementProps) {
	const { showModal } = useModals()
	const { attributes, listeners, setNodeRef } = useDraggable({
		id: block.id,
		data: {
			block,
		},
	})

	return (
		<div
			ref={setNodeRef}
			data-testid={`builder-section-${block.id}-draggable`}
			{...attributes}
		>
			<div className='group flex flex-col items-start gap-2 rounded-lg border bg-input/20 p-3 text-sm leading-tight hover:bg-accent dark:bg-input/30'>
				<div className='flex w-full items-center gap-2'>
					<GripVerticalIcon
						{...listeners}
						className='size-4 shrink-0 cursor-move text-muted-foreground'
					/>

					<div
						className={cn(
							linkButtonVariants({ variant: 'brand' }),
							'line-clamp-3 flex gap-1 text-left font-normal'
						)}
						onClick={() =>
							showModal('SETTINGS_TEMPLATE_MODAL', {
								id: block.id,
								template_type: block.template_type,
							})
						}
					>
						{block.name}
					</div>
				</div>
			</div>
		</div>
	)
}

export function BuilderBlockElementOverlay({
	block,
}: BuilderBlockElementProps) {
	return (
		<div className='group flex flex-col items-start gap-2 rounded-lg border border-primary bg-input/20 p-3 text-sm leading-tight shadow-md hover:bg-accent dark:bg-input/30'>
			<div className='flex w-full items-center gap-2'>
				<GripVerticalIcon className='size-4 shrink-0 cursor-move text-muted-foreground' />
				<div className='line-clamp-3 flex gap-1 text-left font-normal'>
					{block.name}
				</div>
			</div>
		</div>
	)
}
